<template>
    <div>

        <rkm-form
            ref="FormArea"
            show-legend
        >

            <rkm-row class="flex-nowrap">

                <rkm-col class="flex-grow-1">
                    <rkm-form-input
                        label="Área"
                        v-model="model.descricao"
                        :validations="validations.descricao"
                        number
                    />
                </rkm-col>

                <rkm-col class="flex-grow-1">
                    <rkm-form-input
                        label="INE"
                        v-model="model.numeroIne"
                        :validations="validations.numeroIne"
                        number
                        @blur="validateIne"
                        @input="validateIne"
                    />
                </rkm-col>

                <rkm-col class="flex-grow-1">
                    <rkm-form-select
                    :options="data.form.area.tiposArea"
                    textField="descricao"
                    valueField="id"
                    label="Tipo"
                    v-model="model.tipoId"
                    :validations="validations.tipo"
                    :disabled="isTipoDisabled"
                    show-default-option
                    />
                </rkm-col>

                <rkm-col class="flex-grow-0 text-nowrap">

                    <rkm-button
                        :label="false"
                        color="primary"
                        @click="$refs.FormArea.validate(add)"
                    >
                        {{ this.alteracao ? 'Alterar' : 'Incluir' }}
                    </rkm-button>

                    <rkm-button
                        v-if="alteracao"
                        :label="false"
                        color="danger"
                        @click="limpaFormulario()"
                    >
                        Cancelar
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-table
            :items="data.model.area.areas"
            :fields="fields"
            ref="Table"
            sort-by="numeroIne"
        >
            <template v-slot:cell(descricao)="{ item }">
                {{ item.descricao ? item.descricao : 'Não informada' }}
            </template>

            <template v-slot:cell(numeroIne)="{ item }">
                {{ item.numeroIne ? item.numeroIne.padStart(10, '0') : '' }}
            </template>

            <template v-slot:cell(actions)="{ index, item }">

                <rkm-button
                    title="Microárea"
                    color="primary"
                    @click="$refs.ModalMicroarea.open(index, item, data.model.equipe.equipes)"
                    small
                >
                    <rkm-icon
                        icon="th"
                    />
                </rkm-button>

                <rkm-button
                    :disabled="item.microareas.length > 0"
                    @click="handleEdit(index, item)"
                    color="primary"
                    title="Editar"
                    small
                >
                    <rkm-icon icon="pen"/>
                </rkm-button>

                <rkm-button
                    :disabled="item.microareas.length > 0"
                    @click="handleDestroy(item, index)"
                    color="danger"
                    title="Excluir"
                    small
                >
                    <rkm-icon icon="trash"/>
                </rkm-button>
            </template>
        </rkm-table>

        <ModalMicroarea
            :data="data"
            ref="ModalMicroarea"
        />
    </div>
</template>

<script>

// Mixins
import { object } from "@/mixins";

// Modal
import ModalMicroarea from './components/microarea/Modal'

export default {
    components: {
        ModalMicroarea,
    },
    computed: {
        validations() {

            return {
                descricao: { max: 11 },
                numeroIne: { max: 10 },
                tipo: { required: this.model.numeroIne && this.model.numeroIne.length > 0 && this.model.numeroIne.length <= 10 }
            };
        },
        fields() {

            return [
                { key: 'descricao', label: 'Área', sortable: true },
                { key: 'numeroIne', label: 'INE', sortable: true },
                { key: 'tipoDescricao', label: 'Tipo', sortable: true },
                { key: 'actions', label: 'Ações', class: 'col-min text-center' },
            ]
        },
        isTipoDisabled() {
            return !(this.model.numeroIne && this.model.numeroIne.length > 0 && this.model.numeroIne.length <= 10);
        }
    },
    data: () => ({
        alteracao: false,
        index: null,
        model: {
            id: null,
            descricao: null,
            numeroIne: null,
            tipoId: null,
            microareas: [],
        },
    }),
    methods: {
        async validate() {

            return true
        },
        async verificaDuplicidade() {

            const areas = this.clone(this.data.model.area.areas)

            if(this.alteracao) {

                areas.splice(this.index, 1)
            }

            const existeArea = areas.find(area =>
                (area.descricao && area.descricao == this.model.descricao) ||
                (!area.descricao && area.numeroIne && this.model.numeroIne &&
                area.numeroIne.padStart(10, '0') == this.model.numeroIne.padStart(10, '0'))
            );

            if (existeArea !== undefined) {

                this.showValidationNotification('A Área já existe.')

                return false
            }

            return true
        },
        handleEdit(index, item) {

            this.alteracao = true

            this.model.descricao = item.descricao
            this.model.numeroIne = item.numeroIne ? item.numeroIne : null
            this.model.tipoId = item.tipoId ? item.tipoId : null

            this.index = index
        },
        handleDestroy(item) {

            const verificaVinculo = this.data.model.equipe.equipes.filter(e => e.areaId == item.id);

            if(verificaVinculo.length > 0){

                const nomesEquipes = verificaVinculo.map(e => e.unidadeDescricao).join(', ');

                this.showValidationNotification(
                    `A área <strong>${ item.descricao }</strong> que deseja deletar possui vínculos com a(s)` +
                    ` Equipe(s)  <strong>${ nomesEquipes }</strong>. Nesse caso, é necessário deletar a(s) ` +
                    ` Equipe(s) primeiro, se permitido.`
                )

            } else {

                const objIndex = this.data.model.area.areas.findIndex((obj => obj.id == item.id));

                const destroy = async () => this.data.model.area.areas.splice(objIndex, 1)

                this.showDeleteConfirmation(`Deseja realmente excluir o Área <strong>${ item.descricao }</strong>`, destroy,  this.handleError)

            }
        },
        limpaFormulario() {

            this.alteracao = false
            this.index = false

            this.model.descricao = null
            this.model.numeroIne = null
            this.model.tipoId = null
        },
        add() {
            if (this.model.numeroIne === null || this.model.numeroIne === '') {

                this.showAttentionConfirmation(

                    'Área sem equipe vinculada, deseja continuar?',
                    () => {
                        return this.addOrUpdateArea(this.model);
                    },
                    () => {}
                )
            } else {

                this.addOrUpdateArea(this.model)
            }
        },
        addOrUpdateArea(areaOriginal) {

            return new Promise((resolve) => {

                this.verificaDuplicidade()
                    .then(valid => {

                        if (!valid) {

                            return
                        }

                        var area = this.clone(areaOriginal);

                        if (area.tipoId) {
                            let tipo = this.data.form.area.tiposArea.find(t => t.id == area.tipoId);
                            if (tipo) {
                                area.tipoDescricao = tipo.descricao;
                            } else {
                                this.showSaveNotification('Tipo inválido.');
                                return;
                            }
                        } else {
                            area.tipoDescricao = '';
                        }

                        if (area.id == null) {
                            area.id = this.uniqueId('area' + new Date().getTime());
                        }

                        if (this.alteracao) {
                            this.data.model.area.areas[this.index].descricao = area.descricao;
                            this.data.model.area.areas[this.index].numeroIne = area.numeroIne;
                            this.data.model.area.areas[this.index].tipoId = area.tipoId;
                            this.data.model.area.areas[this.index].tipoDescricao = area.tipoDescricao;
                        } else {
                            this.data.model.area.areas.push(area);
                        }

                        this.showSaveNotification('Área incluída com sucesso!');
                        this.limpaFormulario();
                        this.$nextTick().then(() => this.$refs.FormArea.resetValidator());

                    });

                resolve();
            });
        },
        validateIne() {
            if (this.model.numeroIne && this.model.numeroIne.length > 10) {

                this.model.numeroIne = this.model.numeroIne.slice(0, 10);
            }
        },
    },
    mixins: [ object, ],
    props: {
        data: { type: Object, required: true },
    },
}
</script>